export default __webpack_public_path__ + "static/media/add-url.eb4b1824.svg";